/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroundingDataType } from './GroundingDataType';
import {
    GroundingDataTypeFromJSON,
    GroundingDataTypeFromJSONTyped,
    GroundingDataTypeToJSON,
    GroundingDataTypeToJSONTyped,
} from './GroundingDataType';

/**
 * 
 * @export
 * @interface ChatSourceModel
 */
export interface ChatSourceModel {
    /**
     * 
     * @type {string}
     * @memberof ChatSourceModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChatSourceModel
     */
    contentLocation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSourceModel
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ChatSourceModel
     */
    referenceInAnswer: string;
    /**
     * 
     * @type {GroundingDataType}
     * @memberof ChatSourceModel
     */
    groundingDataType: GroundingDataType;
}



/**
 * Check if a given object implements the ChatSourceModel interface.
 */
export function instanceOfChatSourceModel(value: object): value is ChatSourceModel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('referenceInAnswer' in value) || value['referenceInAnswer'] === undefined) return false;
    if (!('groundingDataType' in value) || value['groundingDataType'] === undefined) return false;
    return true;
}

export function ChatSourceModelFromJSON(json: any): ChatSourceModel {
    return ChatSourceModelFromJSONTyped(json, false);
}

export function ChatSourceModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatSourceModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contentLocation': json['contentLocation'] == null ? undefined : json['contentLocation'],
        'title': json['title'],
        'referenceInAnswer': json['referenceInAnswer'],
        'groundingDataType': GroundingDataTypeFromJSON(json['groundingDataType']),
    };
}

export function ChatSourceModelToJSON(json: any): ChatSourceModel {
    return ChatSourceModelToJSONTyped(json, false);
}

export function ChatSourceModelToJSONTyped(value?: ChatSourceModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contentLocation': value['contentLocation'],
        'title': value['title'],
        'referenceInAnswer': value['referenceInAnswer'],
        'groundingDataType': GroundingDataTypeToJSON(value['groundingDataType']),
    };
}

